import React from "react";
import { AlertCircle } from "lucide-react";

/**
 * Displays an error message in a banner
 *
 * @param {Object} props
 * @param {string} props.message - The error message to display
 * @returns {JSX.Element|null}
 */
const ErrorBanner = ({ message }) => {
  if (!message) return null;

  return (
    <div className="flex items-center gap-2 p-4 bg-red-50 border border-red-200 rounded-lg">
      <AlertCircle className="h-5 w-5 text-red-500" />
      <p className="text-sm text-red-700">{message}</p>
    </div>
  );
};

export default ErrorBanner;
